module.exports = __webpack_public_path__ + "img/loser.efb91efd.jpg";